<template>
  <div class="review-page">

    <!-- HEADER -->
   

    <!-- CARD -->
    <div class="review-card">

      <div class="brand-header" :class="'header-'+templete_cat">

        <div class="brand-logo" v-if="businessLogo">
          <img :src="base_url + businessLogo">
        </div>

         <div class="brand-logo" v-if="!businessLogo">
          <img src="/images/logo.png">
        </div>

        <h2 class="brand-title">
          {{ businessName }}
        </h2>

        <!-- <p class="brand-subtitle">
          {{ businessDesc }}
        </p> -->

      </div>

      <h1 v-if="templete_cat === 'temp1'">Tell us How we did</h1>
      <h1 v-if="templete_cat === 'temp2'">Rate your experience with us?</h1>
      <h1 v-if="templete_cat === 'temp3'">How was your experience?</h1>
      <p>{{ businessDesc }}</p>
      <!-- STARS -->
      <!-- TEMPLATE 1 : EMOJI -->
      <div v-if="templete_cat === 'temp1'" class="emoji-rating">
        <button
          class="emoji-btn"
          :class="{ active: rating === 5 }"
          @click="rating = 5"
           v-if="rating<=0 || rating === 5"
        >
          😊
          <span>Great</span>
        </button>

        <button
          class="emoji-btn"
          :class="{ active: rating === 3 }"
          @click="rating = 3"
           v-if="rating<=0 || rating === 3"
        >
          😐
          <span>Okay</span>
        </button>

        <button
          class="emoji-btn"
          :class="{ active: rating === 1 }"
          @click="rating = 1"
           v-if="rating<=0 || rating === 1"
        >
          😞
          <span>Bad</span>
        </button>

      </div>
      <!-- TEMPLATE 2 : STAR -->
      <div v-if="templete_cat === 'temp2'" class="stars">

        <span
          v-for="star in 5"
          :key="star"
          class="material-symbols-outlined"
          :class="{ active: rating >= star }"
          style="font-size: 2.5rem;"
          @click="rating = star"
        >
          star
        </span>

      </div>
      <!-- TEMPLATE 3 : BUTTON CHOICE -->
     <div v-if="templete_cat === 'temp3'" class="choice-rating">

        <div
          class="choice-card good"
          :class="{ active: rating === 5 }"
          @click="rating = 5"
          v-if="rating<=0 || rating === 5"
        >
          <span class="material-symbols-outlined icon">sentiment_satisfied</span>
          <span class="text">Excellent</span>
        </div>

        <div
          class="choice-card avg"
          :class="{ active: rating === 3 }"
          @click="rating = 3"
           v-if="rating<=0 || rating === 3"
        >
          <span class="material-symbols-outlined icon">sentiment_neutral</span>
          <span class="text">Average</span>
        </div>

        <div
          class="choice-card bad"
          :class="{ active: rating === 1 }"
          @click="rating = 1"
           v-if="rating<=0 || rating === 1"
        >
          <span class="material-symbols-outlined icon">sentiment_dissatisfied</span>
          <span class="text">Needs Improvement</span>
        </div>

      </div>

      <div v-if="rating > 0" class="reset-rating">
        <button class="reset-btn" @click="resetRating">
          Change Rating
        </button>
      </div>

      <!-- POSITIVE EXPERIENCE -->
      <!-- <div v-if="rating >= 4" class="feedback positive-box">

        <strong>We're glad you enjoyed it!</strong>
        <p>Please share your experience with us.</p>

        <div class="review-form">

          <div class="form-group">
            <label>Your Name</label>
            <input v-model="form.name" placeholder="John Doe" />
          </div>

          <div class="form-group">
            <label>Email Address</label>
            <input v-model="form.email" placeholder="john@email.com" />
          </div>

          <div class="form-group">
            <label>Your Review</label>
            <textarea
              v-model="form.review"
              placeholder="Tell others about your experience..."
            ></textarea>
          </div>

          <button
            class="primary-btn"
            :disabled="!isFormValid"
            @click="submitReview"
          >
            Submit Review
          </button>


        </div>
      </div> -->

      <!-- NEGATIVE EXPERIENCE -->
      <div v-if="rating>0 && rating <= 3" class="feedback private-box">

        <strong>We value your feedback</strong>
        <p>Please tell us how we can improve.</p>

        <div class="review-form">

          <div class="form-group">
            <label>Your Name</label>
            <input v-model="form.name" placeholder="John Doe" />
          </div>

          <div class="form-group">
            <label>Email Address</label>
            <input type="email" v-model="form.email" placeholder="john@email.com" />
          </div>

          <div class="form-group">
            <label>Mobile</label>

            <div class="phone-input">

              <select v-model="form.countryCode">
                <option value="+1">🇺🇸 +1 United States</option>
                <option value="+1">🇨🇦 +1 Canada</option>
                <option value="+44">🇬🇧 +44 United Kingdom</option>
                <option value="+91">🇮🇳 +91 India</option>
                <option value="+61">🇦🇺 +61 Australia</option>
                <option value="+64">🇳🇿 +64 New Zealand</option>
                <option value="+971">🇦🇪 +971 UAE</option>
                <option value="+966">🇸🇦 +966 Saudi Arabia</option>
                <option value="+974">🇶🇦 +974 Qatar</option>
                <option value="+965">🇰🇼 +965 Kuwait</option>
                <option value="+973">🇧🇭 +973 Bahrain</option>
                <option value="+968">🇴🇲 +968 Oman</option>
                <option value="+65">🇸🇬 +65 Singapore</option>
                <option value="+60">🇲🇾 +60 Malaysia</option>
                <option value="+66">🇹🇭 +66 Thailand</option>
                <option value="+84">🇻🇳 +84 Vietnam</option>
                <option value="+62">🇮🇩 +62 Indonesia</option>
                <option value="+63">🇵🇭 +63 Philippines</option>
                <option value="+81">🇯🇵 +81 Japan</option>
                <option value="+82">🇰🇷 +82 South Korea</option>
                <option value="+86">🇨🇳 +86 China</option>
                <option value="+852">🇭🇰 +852 Hong Kong</option>
                <option value="+886">🇹🇼 +886 Taiwan</option>
                <option value="+49">🇩🇪 +49 Germany</option>
                <option value="+33">🇫🇷 +33 France</option>
                <option value="+39">🇮🇹 +39 Italy</option>
                <option value="+34">🇪🇸 +34 Spain</option>
                <option value="+31">🇳🇱 +31 Netherlands</option>
                <option value="+32">🇧🇪 +32 Belgium</option>
                <option value="+41">🇨🇭 +41 Switzerland</option>
                <option value="+43">🇦🇹 +43 Austria</option>
                <option value="+46">🇸🇪 +46 Sweden</option>
                <option value="+47">🇳🇴 +47 Norway</option>
                <option value="+45">🇩🇰 +45 Denmark</option>
                <option value="+358">🇫🇮 +358 Finland</option>
                <option value="+48">🇵🇱 +48 Poland</option>
                <option value="+420">🇨🇿 +420 Czech Republic</option>
                <option value="+36">🇭🇺 +36 Hungary</option>
                <option value="+40">🇷🇴 +40 Romania</option>
                <option value="+30">🇬🇷 +30 Greece</option>
                <option value="+351">🇵🇹 +351 Portugal</option>
                <option value="+353">🇮🇪 +353 Ireland</option>
                <option value="+7">🇷🇺 +7 Russia</option>
                <option value="+380">🇺🇦 +380 Ukraine</option>
                <option value="+90">🇹🇷 +90 Turkey</option>
                <option value="+27">🇿🇦 +27 South Africa</option>
                <option value="+20">🇪🇬 +20 Egypt</option>
                <option value="+234">🇳🇬 +234 Nigeria</option>
                <option value="+254">🇰🇪 +254 Kenya</option>
                <option value="+212">🇲🇦 +212 Morocco</option>
                <option value="+55">🇧🇷 +55 Brazil</option>
                <option value="+54">🇦🇷 +54 Argentina</option>
                <option value="+56">🇨🇱 +56 Chile</option>
                <option value="+57">🇨🇴 +57 Colombia</option>
                <option value="+51">🇵🇪 +51 Peru</option>
                <option value="+52">🇲🇽 +52 Mexico</option>
                <option value="+92">🇵🇰 +92 Pakistan</option>
                <option value="+880">🇧🇩 +880 Bangladesh</option>
                <option value="+94">🇱🇰 +94 Sri Lanka</option>
                <option value="+977">🇳🇵 +977 Nepal</option>
                <option value="+975">🇧🇹 +975 Bhutan</option>
                <option value="+960">🇲🇻 +960 Maldives</option>
              </select>

              <input
                type="tel"
                v-model="form.mobile"
                placeholder="**********"
              />

            </div>
          </div>


          <div class="form-group">
            <label>Your Feedback</label>
            <textarea
              v-model="form.review"
              placeholder="Share your concerns privately..."
            ></textarea>
          </div>

          <button
            class="primary-btn"
            :disabled="!isFormValid"
            @click="submitReview"
          >
            Submit Feedback
          </button>


        </div>
      </div>

    </div>

    <!-- FOOTER -->
    <div class="review-footer">
      <span>🔒 Secure Feedback Portal</span>
      <span>✔ End-to-End Encrypted</span>
    </div>

    <!-- SUCCESS POPUP -->
    <div v-if="popup.show" class="popup-overlay">
      <div class="popup-card">

        <span class="material-symbols-outlined success-icon">
          check_circle
        </span>

        <h3>{{ popup.title }}</h3>
        <p>{{ popup.message }}</p>

        <button class="popup-btn" @click="popup.show = false">
          Continue
        </button>

      </div>
    </div>

  </div>
</template>
<script>

import { getCampById,sendReview,getGmbReviewLinks  } from "@/apis/campaignapis";
  import { getIntegration } from "@/apis/intigrationapis";
import { apiBaseUrl  } from "@/apis/appconst";
import {useToast} from 'vue-toastification';
export default {
  name: 'ReviewComp',

  data() {
    return {
      toast:null,
      camp_id:"",
      google_inti:false,
      fb_inti:false,
      google_dt:null,
      farwordLink:"",
      platform:"custom",
      templete_cat:"none",
      camp_dt:null,
      businessName: '*********',
      businessLogo: '/images/logo.png',
      businessDesc: '****************',
      base_url:"",
      rating: 0,

      form: {
        name: '',
        email: '',
        mobile: '',
        countryCode: '+91',
        review: ''
      },

      popup: {
        show: false,
        title: '',
        message: ''
      }
    }
  },
  watch:{
  rating(val){
      if(val>3){
        if(this.farwordLink.length>0){
          // alert(this.farwordLink+"");
          window.location.href = this.farwordLink;
        }
        else{
          this.rating = 0;
        }
      }
    }
  },
  mounted(){
    this.toast = useToast();
    this.base_url = apiBaseUrl;
    const segments = window.location.pathname.split("/").filter(seg => seg !== "")+"";
    this.camp_id = segments.split(",")[1]+"";
    this.getCampDt();
  },
  computed: {
    isFormValid() {
      if (this.rating >= 4) {
        return (
          this.form.name.trim() &&
          this.form.email.trim() &&
          this.form.review.trim()
        )
      }

      if (this.rating > 0) {
        return (
          this.form.name.trim() &&
          this.form.review.trim()
        )
      }

      return false
    }
  },

  methods: {
    resetRating(){
      this.rating = 0
    },
    async checkIniti(){
        this.google_inti = await this.loadIntegration("Google","google");
        this.fb_inti = await this.loadIntegration("Facebook","fb");
      },
      async loadIntegration(title, type) {

        try {

          const res = await getIntegration(title, type,this.camp_dt.camp_user);

          if (res.status) {
            this.google_dt = JSON.parse(res.int_dt.intigration_token1+"");
            return true;
          }

           
        } 
        catch (err) {
          console.error(err);
        }
        return true;
      },
     async getCampDt() {

      this.loading = true;

      try {

        const res = await getCampById(this.camp_id);

        if (!res.status) {
          return;
        }

        this.camp_dt = res.tmp;
        this.businessName = this.camp_dt.camp_title;
        this.businessDesc = this.camp_dt.camp_desc;
        this.businessLogo = this.camp_dt.camp_logo ?? "/images/logo.png";
        this.templete_cat = this.camp_dt.camp_templete;
        
        this.platform = this.camp_dt.camp_platform;
        if(this.platform && this.platform==='google'){
          const res1 = await getGmbReviewLinks(this.camp_dt.camp_user);
          if (res1.status && res1.data.length>0) {
            this.farwordLink = res1.data[0].review_link;
          }
        }
        else if(this.platform && this.platform==='facebook'){
          this.farwordLink = "https://facebook.com";
        }
        else if(this.camp_dt.camp_link && this.camp_dt.camp_link.length>0){
          if((this.camp_dt.camp_link+"").includes("http")){
            this.farwordLink = this.camp_dt.camp_link;
          }
          else{
            this.farwordLink = "https://"+this.camp_dt.camp_link;
          }
        }
        
        this.checkIniti();
      } catch (error) {
        console.error(error);
        this.toast.error("Reset failed");
      }

      this.loading = false;
    },
    showPopup(title, message) {
      this.popup.title = title;
      this.popup.message = message;
      this.popup.show = true;
    },

    async submitReview() {

      if (this.rating === 0) {
        this.showPopup("Rating Required", "Please select a star rating.");
        return;
      }

      if (!this.isFormValid) {
        this.showPopup("Incomplete Form", "Please fill required fields.");
        return;
      }

      try {

        const res = await sendReview(
          "google",                  // review_platform
          this.camp_id,              // review_camp
          this.camp_dt.camp_user,    // review_user
          "link",                    // review_source
          this.form.name,
          this.form.email,
          this.form.countryCode+this.form.mobile,                         // review_mobile (optional)
          this.rating,
          this.form.review
        );

        if (!res.status) {
          this.toast.error(res.success);
          return;
        }

        // this.showPopup("Thank You!", "Your feedback was submitted successfully.");
        // this.resetForm();
        window.location.href = "/thank-you";
        // alert("1");

      } catch (error) {
        console.error(error);
        this.toast.error("Submission failed");
      }
    },


    resetForm() {
      this.rating = 0
      this.form.name = ''
      this.form.email = ''
      this.form.mobile = ''
      this.form.review = ''
    }
  }
}
</script>
<style scoped>

/* PAGE */
.review-page {
  min-height: 100vh;
  background: linear-gradient(to bottom right, #f8fafc, rgba(25,127,230,0.04));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  font-family: 'Inter', sans-serif;
}

/* HEADER */
.review-header {
  text-align: center;
  margin-bottom: 26px;
}

.logo-box {
  width: 68px;
  height: 68px;
  border-radius: 18px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  color: #197fe6;
  box-shadow: 0 10px 30px rgba(0,0,0,0.05);
}

.review-header h2 {
  margin-top: 12px;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
}

.verified-badge {
  margin-top: 8px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(25,127,230,0.08);
  color: #197fe6;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
}

/* CARD */
.review-card {
  width: 100%;
  max-width: 520px;
  background: white;
  border-radius: 22px;
  padding: 34px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.06);
  text-align: center;
  border: 1px solid #eef2f7;
}

.review-card h1 {
  font-size: 26px;
  font-weight: 900;
  color: #0f172a;
}

.review-card p {
  margin-top: 6px;
  color: #64748b;
  font-size: 14px;
}

/* STARS */
.stars {
  display: flex;
  justify-content: center;
  gap: 6px;
  margin: 24px 0;
}

.stars span {
  font-size: 42px;
  cursor: pointer;
  color: #e2e8f0;
  transition: 0.2s ease;
}

.stars span:hover {
  transform: scale(1.08);
}

.stars span.active {
  color: #fbbf24;
}

/* FEEDBACK BOXES */
.feedback {
  margin-top: 18px;
  text-align: left;
}

.positive-box {
  background: #f0fdf4;
  border-radius: 14px;
  padding: 18px;
}

.private-box {
  background: #f8fafc;
  border-radius: 14px;
  padding: 18px;
}

.feedback strong {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.feedback p {
  margin-top: 2px;
  font-size: 13px;
}

/* FORM */
.review-form {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.form-group label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.form-group input,
.form-group textarea {
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  transition: 0.2s;
}

.form-group textarea {
  resize: none;
  min-height: 90px;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #197fe6;
  box-shadow: 0 0 0 3px rgba(25,127,230,0.08);
}

/* BUTTON */
.primary-btn {
  height: 46px;
  border-radius: 12px;
  background: #197fe6;
  color: white;
  font-size: 13px;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: 0.2s;
  margin-top: 6px;
}

.primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 20px rgba(25,127,230,0.25);
}

.primary-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* FOOTER */
.review-footer {
  margin-top: 18px;
  display: flex;
  gap: 20px;
  font-size: 11px;
  color: #94a3b8;
}

/* MOBILE */
@media (max-width: 768px) {

  .review-card {
    padding: 24px;
    border-radius: 18px;
  }

  .review-card h1 {
    font-size: 22px;
  }

  .stars span {
    font-size: 34px;
  }

  .review-footer {
    flex-direction: column;
    gap: 6px;
    text-align: center;
  }
}
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.popup-card {
  width: 100%;
  max-width: 380px;
  background: white;
  border-radius: 18px;
  padding: 26px;
  text-align: center;
  box-shadow: 0 30px 60px rgba(0,0,0,0.12);
  animation: popupEnter 0.25s ease;
}

.success-icon {
  font-size: 42px;
  color: #22c55e;
  margin-bottom: 10px;
}

.popup-card h3 {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.popup-card p {
  font-size: 13px;
  color: #64748b;
  margin-top: 6px;
}

.popup-btn {
  margin-top: 16px;
  height: 42px;
  width: 100%;
  border-radius: 10px;
  background: #197fe6;
  color: white;
  font-weight: 700;
  border: none;
  cursor: pointer;
}

.popup-btn:hover {
  background: #0f6ad6;
}

@keyframes popupEnter {
  from {
    transform: scale(0.96);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.emoji-rating{
display:flex;
justify-content:center;
gap:20px;
margin:20px 0;
}

.emoji-btn{
display:flex;
flex-direction:column;
align-items:center;
font-size:2.5rem;
background:none;
border:none;
cursor:pointer;
}

.emoji-btn span{
font-size:12px;
font-weight:600;
margin-top:6px;
}.choice-rating {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.choice-card {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 48px;
  padding: 0 16px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  opacity: 0.7;
}

.choice-card:hover {
  transform: translateY(-1px);
}

.choice-card.active {
  opacity: 1;
  transform: scale(1.02);
  box-shadow: 0 8px 18px rgba(0,0,0,0.12);
}

/* COLORS */

.choice-card.good {
  background: #22c55e;
  color: white;
}

.choice-card.avg {
  background: #f59e0b;
  color: white;
}

.choice-card.bad {
  background: #ef4444;
  color: white;
}

.choice-card .icon {
  font-size: 20px;
}

/* BRAND HEADER */
.brand-header{
display:flex;
flex-direction:column;
align-items:center;
text-align:center;
margin-bottom:26px;
}

.brand-logo{
height:5rem;
background:white;
display:flex;
align-items:center;
justify-content:center;
overflow:hidden;
margin-bottom:12px;
}

.brand-logo img{
width:auto;
height:5rem;
object-fit:cover;
}

.brand-logo span{
font-size:32px;
}

.brand-title{
font-weight:800;
}

.brand-subtitle{
font-size:13px;
max-width:280px;
}

.emoji-btn{
display:flex;
flex-direction:column;
align-items:center;
font-size:2.5rem;
background:none;
border:none;
cursor:pointer;
opacity:0.5;
transition:all 0.2s ease;
}

.emoji-btn.active{
opacity:1;
transform:scale(1.15);
}
.reset-rating{
margin-top:10px;
}

.reset-btn{
background:none;
border:none;
color:#197fe6;
font-size:12px;
font-weight:600;
cursor:pointer;
}

.reset-btn:hover{
text-decoration:underline;
}

.phone-input{
display:flex;
gap:8px;
}

.phone-input select{
width:110px;
border:1px solid #e2e8f0;
border-radius:10px;
padding:10px;
font-size:13px;
background:white;
}

.phone-input input{
flex:1;
}
</style>

